<template>
  <section class="section section__content --links">
    <HeadingBlock :content="content" />
    <ul class="link__list">
      <LinkCard
        :content="item"
        v-for="(item, itemIndex) in content.list"
        :key="item.flexKey"
        v-reveal="{ delay: 50 * itemIndex + 250 }"
      />
    </ul>
  </section>
</template>

<script>
import { HeadingBlock } from '@/components/blocks'
import { LinkCard } from '@/components/cards'
import { DefaultSectionProps } from '@/mixins'

export default {
  name: 'LinksListSection',
  mixins: [DefaultSectionProps],
  components: { HeadingBlock, LinkCard },
}
</script>
